import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data53 from '../../data/data53.json'
import { Carousel, Image } from 'antd';
import banner1 from '../../static/banner1.png'
import banner2 from '../../static/banner2.png'
import ArticleList from '../../Components/ArticleList';
const HearLove: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>听见爱</h1>
                {/* 页面内容将在这里添加 */}
                <div className="intro-container" >
                    <div className="intro-text" >
                        <p>爱咪听见社区心理驿站，落地于杭州栖霞岭社区党群服务中心，服务于全杭州民众。聘请专业心理咨询师，上午提供个体心理咨询服务，下午提供团体心理辅导服务。

2023年10月至12月，爱咪听见项目共举办线上线下活动13场，项目共支出 3000元，直接间接受益人数近1000人次。</p>
                    </div>
                    <div className="intro-carousel" >
                        <Carousel autoplay>
                            <div>
                                <Image src={banner1} alt="轮播图1" />
                            </div>
                            <div>
                                <Image src={banner2} alt="轮播图1" />
                            </div>
                        </Carousel>
                    </div>
                </div>
                <ArticleList dataId="53" data={data53 as any} />
            </div>
        } />
    );
};

export default HearLove;